<header class="header header-10 header-intro-clearance">
    <div class="header-top">
        <div [class]="containerClass">
            <div class="header-left">
                <ul class="top-menu">
                    <li>
                        <a href="javascript:;">Contatti</a>
                        <ul>
                            <li>
                                <a href="tel:+390444821261">
                                    <i class="icon-phone"></i>TEL: +39 0444 82 12 61
                                </a>
                            </li>
                            <li>
                                <a href="mailto:info@myliteled.com">
                                    <i class="icon-envelope"></i>EMAIL: info@myliteled.com
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="header-right">

                <ul class="top-menu">
                    <li class="login" *ngIf="!loginModel">
                        <a href="javascript:;" (click)="showLoginModal($event)">LoginI</a>
                    </li>
                    <li class="dashboard" *ngIf="loginModel">
                        <a href="javascript:;" routerLink="shop/dashboard">My Account</a>
                    </li>
                </ul>

            </div>
        </div>
    </div>

    <div class="header-middle">
        <div [class]="containerClass">
            <div class="header-left">
                <molla-mobile-button></molla-mobile-button>

                <a routerLink="/" class="logo">
                    <img src="assets/images/home/logo.png" alt="MyLiteLED" width="220" height="60">
                </a>
            </div>

            <div class="header-center">
                <molla-header-search [categories]="categories"></molla-header-search>
            </div>

            <div class="header-right">
                <div class="header-dropdown-link">
                    <!--a href="javascript:;" (click)="onCalcolatoreClick($event)" class="wishlist-link" title="Calcolatore">
                        <i class="icon-tools"></i>
                        <span class="wishlist-txt">Calcolatore</span>
                    </a-->

                    <a href="javascript:;" (click)="showLoginModal($event)" class="wishlist-link" title="Accedi / Registrati">
                        <i class="icon-user"></i>
                        <span class="wishlist-txt">{{ this.loginModel && this.loginModel.username ?
                            this.loginModel.username : 'Accedi / Registrati' }}</span>
                    </a>

              
                    <molla-wishlist-menu *ngIf="loginModel && loginModel.token"></molla-wishlist-menu>

                    <molla-cart-menu *ngIf="loginModel && loginModel.token"></molla-cart-menu>
                  
                </div>
            </div>
        </div>
    </div>

    <div class="sticky-wrapper" [style.height]="utilsService.isSticky? utilsService.stickyHeight + 'px' : '' ">
        <div class="header-bottom sticky-header" [class.fixed]="utilsService.isSticky">
            <div [ngClass]="containerClass">
                <div class="header-left">
                    <molla-category-menu [categories]="categories"></molla-category-menu>
                </div>

                <div class="header-right">
                    <nav class="main-nav" itemscope itemtype="http://schema.org/SiteNavigationElement">
                        <ul class="menu sf-arrows">
                            <li [class.active]="current.includes('/cataloghi-prodotti')">
                                <a href="javascript:;" class="sf-with-ul">Cataloghi</a>

                                <div class="megamenu megamenu-sm">
                                    <div class="row no-gutters">
                                        <div class="col-md-6">
                                            <div class="menu-col">
                                                <div class="menu-title">Download</div>

                                                <ul>
                                                    <li>
                                                        <a routerLink="/pages/cataloghi-prodotti/catalogo">CATALOGO</a>
                                                    </li>
                                                    <li>
                                                        <a routerLink="/pages/cataloghi-prodotti/flex-neonled">FLEX
                                                            NEONLED SIGN</a>
                                                    </li>
                                                    <li>
                                                        <a routerLink="/pages/cataloghi-prodotti/led-wall">LED WALL</a>
                                                    </li>
                                                    <li
                                                        [class.active]="current.includes('pages/cataloghi-prodotti/m-flex')">
                                                        <a routerLink="/pages/cataloghi-prodotti/-flex">PROFILI
                                                            M-FLEX</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="banner banner-overlay">
                                                <a routerLink="/shop/sidebar/list">
                                                    <img src="assets/images/menu/banner-2.jpg" alt="Banner" width="218"
                                                        height="310" />

                                                    <div class="banner-content banner-content-bottom">
                                                        <div class="banner-title text-white">

                                                            <br />

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li routerLink="/pages/contact" [class.active]="current.includes('/pages/contact')">
                                <a routerLink="/pages/contact">Contatti</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</header>